import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postCompaniesCompanyIdEmailSelfServeIpPoolsCacheKeys } from "./constants";
import type {
  PostCompaniesCompanyIdEmailSelfServeIpPoolsProps,
  PostCompaniesCompanyIdEmailSelfServeIpPoolsResult,
  PostCompaniesCompanyIdEmailSelfServeIpPoolsResultErrors,
} from "./types";

/**
 * POST handler for the "/companies/:company_id/email_self_serve/:app_group_id/ip_pools" endpoint
 */
export const postCompaniesCompanyIdEmailSelfServeIpPools = reactQueryMutationAdapter(
  postCompaniesCompanyIdEmailSelfServeIpPoolsCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostCompaniesCompanyIdEmailSelfServeIpPoolsResultErrors>()(
    ({
      companyId,
      appGroupId,
      pools,
      questionnaire,
    }: PostCompaniesCompanyIdEmailSelfServeIpPoolsProps): Promise<PostCompaniesCompanyIdEmailSelfServeIpPoolsResult> => {
      return fetch(
        `/companies/${companyId}/email_self_serve/${appGroupId}/ip_pools`,
        "POST",
        { pools, questionnaire },
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
